import { UserInfo } from "./types";

export const getQueryParamsFromObject = (
  obj: Record<string, string | boolean | number>,
  filterUndefinedOrNull: boolean = true
): string => {
  let objectEntries = Object.entries(obj);

  if (filterUndefinedOrNull) {
    objectEntries = objectEntries.filter(([_, value]) => {
      return value !== undefined && value !== null;
    });
  }

  if (objectEntries.length === 0) {
    return "";
  }

  const queryParams = objectEntries
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .filter((param) => param) // Filter out any empty strings from the map step
    .join("&");

  return queryParams;
};

export const getEmailsOfUsersAlreadyInCompany = (
  usersInfoById: { [userAccountId: string | number]: UserInfo },
  emailAddresses: string[]
) => {
  const emailsOfUsersAlreadyInCompany: string[] = [];
  const emailAddressesCopy = [...emailAddresses].map((emailAddress) =>
    emailAddress.toLowerCase()
  );
  const errorMap: Record<string, string> = {};
  Object.values(usersInfoById).forEach((user) => {
    const emailAddressIndex = emailAddressesCopy.indexOf(
      user.emailAddress.toLowerCase()
    );

    if (emailAddressIndex !== -1) {
      emailsOfUsersAlreadyInCompany.push(user.emailAddress);
      emailAddressesCopy.splice(emailAddressIndex, 1);
      errorMap[
        user.emailAddress
      ] = `'${user.emailAddress}' is already in company.`;
    }
  });

  return { emailsOfUsersAlreadyInCompany, errorMap };
};
